import { Components } from "@mui/material/styles";

const components: Components = {
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: "uppercase",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "15.4px",
                letterSpacing: "normal",
                borderRadius: "8px",
                minWidth: "64px",
                boxShadow: "none",
                transition:
                    "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                    boxShadow: "none",
                },
            },
            contained: {
                height: "44px",
                padding: "0 40px 0 32px",
            },
            containedPrimary: {
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(0, 0, 0)",
                "&:hover": {
                    backgroundColor: "rgb(240, 240, 240)", // Slightly darker on hover
                },
            },
        },
        defaultProps: {
            disableElevation: true,
        },
    },
};

export default components;
